export class FileStorageDTO {
  /**
   * Directory in cui viene salvato il file sullo storage
   */
  directory!: string;

  /**
   * Id univoco e nome del file all'interno della directory
   */
  fileId!: string;

  /**
   * Chiave del file sul bucket di S3
   */
  objKey!: string

}
